import {useGetMoneyAmountQuery} from "../apis/game-income.api";

export function useTanjiBalance(): { value: number, isLoading: boolean } {
  const {data: money, isLoading} = useGetMoneyAmountQuery();
  return {value: money ? money.amount : 0, isLoading};
}
